/**
 * Created for localizing moment.js
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */

import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import 'moment/locale/zh-cn';

@Injectable({
  providedIn: 'root'
})
export class MomentService {
  private localeMap = {
    en: 'en',
    ch: 'zh-cn'
  };

  constructor(private translateService: TranslateService) {
    this.setLocale(this.translateService.currentLang || 'en');

    this.translateService.onLangChange.subscribe(event => {
      this.setLocale(event.lang);
    });
  }

  setLocale(locale: string) {
    const momentLocale = this.localeMap[locale] || 'en';
    moment.locale(momentLocale);
  }

  format(date: moment.MomentInput, formatStr: string) {
    return moment(date).format(formatStr);
  }
}
